import { memo, useEffect, useState } from "react";
import Input from "../../components/input/input";
import styles from '../loginSignup.module.css';
import Button from "../../components/button/button";
import { changePassword, resetPasswordPassword } from "../../services/api";
import { useSearchParams } from "react-router-dom";


export default memo(function ChangePassword({ from, setinfoPopup, changeState }) {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [token, setToken] = useState('')
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const token = searchParams.get("token");
        setToken(token)
    }, [searchParams])
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/;

    const handleVerifySubmit = async () => {
        if (from === 'user') {
            const changeStatus = await changePassword(newPassword)
            if (changeStatus.ok) changeState(changeStatus.message, false, false)
            else changeState(changeStatus.message, false, true)
        } else {
            const resetPassword = await resetPasswordPassword(token, newPassword)
            if (resetPassword.ok) setinfoPopup({ show: true, message: 'Password reset successful! You can now log in with your new password.' });
            else setinfoPopup({ show: true, message: 'Error.  Please try again or reach out to support for assistance.' });
        }
    };

    return (
        <>
            <h2>Change Password</h2>
            <p style={{ fontFamily: "montserrat, sans-serif", fontWeight: "Medium", fontSize: "15px", padding: "10px" }}>Enter a new password below to change your password.</p>
            <div className={styles.inputcontainer}>
                <Input
                    id="newPassword"
                    label="New Password *"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    style={newPassword?.length > 0 && (newPassword?.length < 8 || !regex.test(newPassword)) ? { border: '1px solid red' } : null}
                    autoComplete="new-password"
                    errText={newPassword?.length > 0 && (newPassword?.length < 8 || !regex.test(newPassword)) ? 'Password must have uppercase, lowercase, number, symbol, and be 8 or more characters.' : null}
                />
                <Input
                    id="re-enterPassword"
                    label="Re-enter New Password *"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    autoComplete="new-password"
                    style={confirmPassword !== newPassword && newPassword?.length >= 8 && confirmPassword?.length >= 8 ? { border: '1px solid red' } : null}
                    errText={confirmPassword !== newPassword && newPassword?.length >= 8 && confirmPassword?.length >= 8 ? 'Passwords do not match.' : null}
                />
                <Button onClick={() => handleVerifySubmit()} children={'Save Password'} disabled={!regex.test(newPassword) || confirmPassword !== newPassword || !newPassword || newPassword?.length < 8} />
            </div>
        </>
    )
})